<template>
    <vue-scroll :ops="ops">
        <div class="joinus">
            <HeaderMei></HeaderMei>
            <div class="content">
                <div class="title">
                    <span></span>
                    重庆美天科技有限公司<em>Chongqing Meitian Technology Co.,Ltd</em>
                    <i></i>
                </div>
                <div class="js">
                    重庆美天科技作为一家专注气象的互联网公司，拥有专业气象互联网团队，他们来自全国各地有着不同文化背景，但都同样具备非凡的才能和高度的团队合作精神。目前气象作为经济建设、国防建设、社会发展和人民生活的科技型基础性公益事业，在未来经济社会发展中的地位和作用日益重要。我们坚信人才是公司未来发展的基石，我们愿与加入美天的每一位同事共同成长，共同分享每一次成功的喜悦。
                </div>
                <div class="title" style="width: 161px;margin-top: 80px">
                    <span style="width: 120px"></span>
                    美天福利<em style="text-align: left">MT Welfare</em>
                    <i style="right: 0px"></i>
                </div>
                <div class="js">
                    美天科技是重庆市内规模最大、综合实力最强的气象科技公司之一，为美天成员提供均等的发展机会和具有吸引力的福利。公司以完善的人力资源制度、专业的激励体制和良好的福利制度保证每一位同事及时得到工作成果认可。常规福利制度包括且不限于：五险一金、入职年假、带薪事假、调休制度、年终分红、活动团建、免费培训与节日福利。
                </div>
                <!--<div class="title" style="width: 161px;margin-top: 40px;text-align: left">-->
                    <!--<span style="width: 120px"></span>-->
                    <!--热招职位<em style="text-align: left">Recruitment position</em>-->
                    <!--<i style="right: 0px"></i>-->
                <!--</div>-->
                <!--<div class="position" v-for="item in positions">-->
                    <!--<div class="items">-->
                        <!--{{item.name}}-->
                    <!--</div>-->
                <!--</div>-->
            </div>
            <FooterMei></FooterMei>
        </div>
    </vue-scroll>
</template>

<script>
import HeaderMei from '@/components/headerMei';
import FooterMei from '@/components/footerMei';

export default {
    name: 'joinus',
    components: { HeaderMei, FooterMei },
    data() {
        return {
            ops: {
                rail: {
                    background: '#01a99a',
                    opacity: 0,
                    size: '0px',
                    specifyBorderRadius: false,
                    gutterOfEnds: null,    //轨道距 x 和 y 轴两端的距离
                    gutterOfSide: '0',   //距离容器的距离
                    keepShow: false,   //是否即使 bar 不存在的情况下也保持显示
                    border: 'none'    //边框
                }
            },
            positions: [
                {name: 'JAVA开发工程师', path: '#'},
                {name: '算法工程师', path: '#'},
                {name: '前端开发工程师', path: '#'},
                {name: 'UE设计师', path: '#'},
                {name: '产品经理', path: '#'},
                {name: '售前工程师', path: '#'}
            ]
        }
    }
}
</script>

<style scoped lang="less">
    .joinus {
        width: 100%;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        height: 100vh;
        .content {
            flex: 1;
            padding: 0 20px;
            color: #ffffff;
            .title {
                width: 300px;
                position: relative;
                font-size: 30px;
                height: 70px;
                margin-top: 60px;
                em {
                    font-style: normal;
                    display: block;
                    font-size: 16px;
                }
                i {
                    display: inline-block;
                    width: 60px;
                    height: 1px;
                    background-color: #ffffff87;
                    position: absolute;
                    bottom: 6px;
                    right: 0px;
                }
                span {
                    display: inline-block;
                    width: 146px;
                    height: 1px;
                    background-color: #ffffff87;
                    position: absolute;
                    top: -2px;
                    left: 0px;
                }
            }
            .js {
                width: 51%;
                line-height: 30px;
                font-size: 15px;
                margin-top: 10px;
                letter-spacing: 1px;
            }
            .position{
                margin-top: 10px;
                margin-left: -2%;
                .items{
                    float: left;
                    width: 14.5%;
                    margin-left: 2%;
                    border: 1px solid #ddd;
                    text-align: center;
                    padding: 20px 0;
                    margin-top: 20px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/joinus.vue